<template>
  <div class="painpoint">
    <div class="header">
      <div class="title">行业痛点 物业难题</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item" v-for="item in painpointList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilepainpoint1 from "../../../../assets/product/mobilepainpoint1.png";
import mobilepainpoint2 from "../../../../assets/product/mobilepainpoint2.png";
import mobilepainpoint3 from "../../../../assets/product/mobilepainpoint3.png";
import mobilepainpoint4 from "../../../../assets/product/mobilepainpoint4.png";
import mobilepainpoint5 from "../../../../assets/product/mobilepainpoint5.png";

export default {
  setup() {
    return reactive({
      painpointList: [
        {
          id: 1,
          title: "物业收费难",
          text: "物企普遍存在的最大问题就是收费困难",
          logo: mobilepainpoint1,
        },
        {
          id: 2,
          title: "物企盈利难",
          text: "物业运营和管理成本高，人力成本居高不下且不断提升。",
          logo: mobilepainpoint2,
        },
        {
          id: 3,
          title: "物企响应慢",
          text: "物企工作人员工作效率较低，工作主动性不够高。",
          logo: mobilepainpoint3,
        },
        {
          id: 4,
          title: "物企管理缺乏",
          text: "大部分物企还未形成完整、系统的管理体系，缺乏有效的制度来规范管理流程。",
          logo: mobilepainpoint4,
        },
        {
          id: 5,
          title: "业主满意度低",
          text: "业主与物企矛盾尖锐，沟通存在困难。",
          logo: mobilepainpoint5,
        },
      ],
    });
  },
};
</script>

<style scoped>
.painpoint {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body .list {
  width: 92vw;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
}
.body .list .item {
  width: 162px;
  text-align: center;
  margin-bottom: 16px;
}
.body .list .item img {
  width: 48px;
}
.body .list .item .title {
  font-size: 14px;
  margin-top: 8px;
  font-weight: 600;
}
.body .list .item .text {
  color: #495a6c;
  font-size: 12px;
  margin-top: 8px;
}
</style>
